import { render, staticRenderFns } from "./VideoAccel.vue?vue&type=template&id=6b9a165a"
import script from "./VideoAccel.vue?vue&type=script&lang=ts"
export * from "./VideoAccel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports